import { css } from "styled-components"

export const colors = {
  green: "#1BBE65",
  red: "#EA064C",
  redMedium: "#E21550",
  white: "#ffffff",
  black: "#000000",
  blueLight: "#E0F4FF",
  blueMedium: "#3C94C4",
  blueDark: "#2E62C3",
  gray: "#E4E8F1",
  pink: "rgb(255, 210, 218)",

  //scale gray
  grey5: "#a0a0a0",
  grey10: "#E0E0E0",
  grey15: "#888888",
  grey20: "#B8B8B8",
  grey25: "#DBDBDB",
  grey30: "#636363",
  grey35: "#F4F5F8",
  grey40: "#8F8F8F",
  grey45: "#8E8E8E",
  grey50: "#686c73",
  grey60: "#30363d",
  grey65: "#616161",
  grey70: "#616369",
  grey75: "#434343",
  grey80: "#484848",
  grey85: "#595354",
  grey90: "#1F1F1F",
  grey95: "#272727",
  grey100: "#2E2E2E",
  gery105: "#838383",
  grey110: "#818181",
  grey115: "#f2f4f7",
  grey120: "#354052",
  grey125: "#cccccc",
  grey130: "#616060", 

  colorIconDefault: "#A4A4A4",
  transparentGray: "rgba(44,44,44,0.58)",
  redWarning: "#ff0000",
}

export const greyScale = {
  white: "#FFFFFF",
  transparentGrey: "rgba(44,44,44,0.58)",
  grey5: "#ECEDF1",
  grey10: "#E5E7ED",
  grey20: "#CBCCD8",
  grey30: "#A1A2BA",
  grey40: "#81819F",
  grey50: "#656182",
  grey60: "#3E405B",
  grey70: "#333152",
  grey75: "#616369",
  grey80: "#20213C",
  grey85: "#484848",
  grey90: "#1A1B26",
  black: "#000000",
}

export const fontSizes = { mainSize: "14px", secondsize: "16px" }

export const displays = {
  flexBase: css`
    display: flex;
    align-items: center;
  `,
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  flexEvenly: css`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  `,

  flexColumn: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,

  flexEnd: css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
  `,

  flexWrap: css`
    display: flex;
    flex-wrap: wrap;
  `,
}

export const textuppercase = css`
  text-transform: uppercase;
`

export const breakpointsMedia = {
  xs: "480px",
  sm: "768px",
  md: "992px",
  lg: "1200px",
}

export const boxShadow = {
  shadow02: css`
    box-shadow: 0 2px 4px 4px rgba(45, 18, 65, 0.15);
  `,
  shadow04: css`
    box-shadow: 0 4px 8px 8px rgba(45, 18, 65, 0.15);
  `,

  shadow06: css`
    box-shadow: 0 5px 10px 8px rgba(45, 18, 65, 0.15);
  `,

  shadow12: css`
    box-shadow: 0 12px 24px 8px rgba(45, 18, 65, 0.15);
  `,

  shadow24: css`
    box-shadow: 0 24px 48px 8px rgba(45, 18, 65, 0.15);
  `,
}
